import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { environment } from '../../environments/environment';
import { SendLineMessageService } from 'src/app/adapters/sendLineMessage.service';
import { GetRenewalDetailService } from 'src/app/adapters/getRenewalDetail.service';
import { GetRenewalNonmotorDetailService } from 'src/app/adapters/getRenewalNonmotorDetail.service';
import { CallNotify } from 'src/app/adapters/callNotify.service';
import { ConstantsService } from '../shared/service/constants/constants.service';
import { BaseComponents } from '../base.component';
import { Injectable, Injector } from '@angular/core';
import { SharedDataService } from '../shared/shared-data.service';
import { updateRenewNonMotorOmiseService } from '../adapters/updateRenewNonMotorOmise.service';
import { GetWrapUpQrPayment } from 'src/app/adapters/getWrapUpQrPayment.service';
import { GetNonMotorPaymentSummary } from 'src/app/adapters/getNonMotorPaymentSummary.service';
import { CallTss } from 'src/app/adapters/callTss.service';
import { updateF09StatusService } from 'src/app/adapters/updateF09Status.service';
import { CheckWrapUpNonMotorService } from 'src/app/adapters/checkWrapUpNonMotor.service';
import * as uuid from 'uuid';
import { SharedModule } from "../shared/shared.module";
import { TiscoModalComponent } from "../shared/component/tisco-modal/tisco-modal.component";
import liff from '@line/liff';
import { ModalService } from "src/app/shared/service/modal/modal.service";
import { LineModalTemplateService } from "src/app/shared/service/modal/components/line-modal-template/line-modal-template.service";
import { LineModalTemplateComponent } from "src/app/shared/service/modal/components/line-modal-template/line-modal-template.component";
import { ReferenceService } from "src/app/services/reference.service";
import { GetMaskingService } from '../adapters/getMasking.service';
declare var window: any;
@Component({
  selector: 'app-renewal',
  templateUrl: './renewal.component.html',
  styleUrls: ['./renewal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false 
})
export class RenewalComponent extends BaseComponents implements OnInit {

  url_default: string;

  navigationExtras: any;

  insurance_data: any;

  rm_channelId: string;
  liffId: string;
  ducid: string;
  lucid: string;
  page: string;
  product_type: number;
  paymentMethod: string;
  amount: string;
  // userId: string;
  electronic_channel: string;
  comcode: string;

  result: any;
  payment_method: string;
  card_number: string;

  day_current: number;
  month_current: number;
  year_current: number;
  hr_current: number;
  minute_current: number;

  check_rule: boolean = false;

  credit_status:number;
  liff_channel_id:string = "";
  channel_line_id:string= "";
  logSessionText:string = `renewal ${uuid.v4()} =>`
  referenceUUID: string | null = null;
  subChannel:number| null = null;
  isCompulsory:boolean = false;
  @ViewChild(TiscoModalComponent) modal;

  constructor(
    //private logger: NGXLogger,
    protected injectorObj:Injector,
    private route: ActivatedRoute,
    private router: Router,
    private sendLineMessageService: SendLineMessageService,
    private getRenewalDetailService: GetRenewalDetailService,
    private getRenewalNonmotorDetailService: GetRenewalNonmotorDetailService,
    private ConstantsService: ConstantsService,
    private sharedDataService: SharedDataService,
    private callNotify: CallNotify,
    private updateRenewNonMotorOmiseService: updateRenewNonMotorOmiseService,
    private getWrapUpQrPayment: GetWrapUpQrPayment,
    private getNonMotorPaymentSummary: GetNonMotorPaymentSummary,
    private callTss: CallTss,
    private updateF09StatusService: updateF09StatusService,
    private checkWrapUpNonMotorService: CheckWrapUpNonMotorService,
    private modalService: ModalService,
    private lineModalService: LineModalTemplateService,
    private referenceService: ReferenceService,
    private getMaskingService: GetMaskingService
  ) {
    super(injectorObj);
    var dateObj = new Date();
    this.month_current = dateObj.getUTCMonth() + 1;
    this.day_current = dateObj.getDate();
    this.year_current = dateObj.getUTCFullYear();
    this.hr_current = dateObj.getHours();
    this.minute_current = dateObj.getMinutes();
  }

  // electronic_channel 1 = tisco insure , 2 = mazda , 3 = ford

  async ngOnInit() {

    if (environment.log_level == 'debug') {
      window.vConsole = new window.VConsole();
    }
    this.referenceUUID = this.referenceService.getReferenceUUID();
    this.logSessionText = `renewal ${uuid.v4()} referenceUUID:[${this.referenceUUID}] =>`;
    await this.route.queryParams.subscribe(async (params) => {
      this.logger.debug(params);
      if (params['liff.state']) {
        this.url_default = decodeURIComponent(window.location.search).replace("?liff.state=", "");
        this.url_default = decodeURIComponent(this.url_default).replace("?dataucid=", "&dataucid=");
        this.logger.debug('window.location.search ' + window.location.search)
        this.logger.debug('url_default ' + this.url_default)
        const param = new URLSearchParams(this.url_default)
        this.rm_channelId = param.get('rm_channelId');
        this.liffId = param.get('appRef');
        this.ducid = param.get('dataucid');
        this.lucid = param.get('letterucid');
        this.page = param.get('page');
        this.paymentMethod = param.get('payment_method');
        this.product_type = parseInt(param.get('product_type'));
        this.electronic_channel = param.get('electronic_channel');
        this.comcode = param.get('comcode');
        this.amount = param.get('amount');
        this.credit_status = param.get('credit_status') ? parseInt(param.get('credit_status')) : null;        
        this.liff_channel_id = param.get('liff_channel_id');
        this.channel_line_id = param.get('channel_line_id');
        this.subChannel = param.get('subchannel') ? parseInt(param.get('subchannel')) : null;
        this.logger.debug('rm_channelId :' + this.rm_channelId);
        this.logger.debug('liffId :' + this.liffId);
        this.logger.debug('ducid :' + this.ducid);
        this.logger.debug('lucid :' + this.lucid);
        this.logger.debug('page :' + this.page);
        this.logger.debug('product_type :' + this.product_type);
        this.logger.debug('paymentMethod :' + this.paymentMethod);
        this.logger.debug('amount :' + this.amount);
      }
      else {
        this.rm_channelId = params['rm_channelId'];
        this.liffId = params['appRef'];
        this.ducid = params['dataucid'];
        this.lucid = params['letterucid'];
        this.page = params['page'];
        this.paymentMethod = params['payment_method'];
        this.amount = params['amount'];
        this.result = params['result']
        this.payment_method = params['payment_method']
        this.product_type = params['product_type'];
        this.card_number = params['card_number']
        this.electronic_channel = params['electronic_channel'];
        this.comcode = params['comcode'];
        this.credit_status = params['credit_status'];
        this.liff_channel_id = params['liff_channel_id'];
        this.channel_line_id = params['channel_line_id']
        this.subChannel = params['subchannel'] ? parseInt(params['subchannel']) : null;
        this.logger.debug('else', params)
      }
    });    
    try {
      this.logger.info('before call liff.init');

      // if (environment.production){
      //   await liff.init({ liffId: this.liffId ? this.liffId : '1653923162-wJQEqrYj' })
      //   this.logger.info('callback path : ' + window.location.href);
      //   if (liff.isLoggedIn() == false && liff.isInClient() == false) {
      //     this.logger.info('login liff');
      //     liff.login({ redirectUri: window.location.href });
      //   }else{
      //     this.access_token_line = await liff.getAccessToken();
      //     this.logger.debug([this.logger_text,'access_token_line:', this.access_token_line]);
      //   }
       
      // }
            
      if (this.page.includes('payment-callback')) {
        this.onRedirect();
      }
      else {
        this.logger.info('get lineprofile success ');
        await this.checkRule(this.ducid, this.lucid);
      }
      // this.logger.debug('user id ' + this.userId);
      this.logger.debug('page' + this.page);
    }
    catch (e) {
      // this.userId = ''
      this.logger.error([this.logSessionText,'Error ',e.message]);
      this.router.navigate(['/renewal/page-error']);
    };
  }

  async checkRule(dataucid: any, letterucid: any) {
    this.logger.info(`${this.logSessionText} checkRule product_type:'${this.product_type}`)
    if (this.product_type == this.ConstantsService.MOTOR) {
      this.getRenewalDetailService.exec({ dataucid: dataucid, letterucid: letterucid }).then((res: any) => {
        this.logger.debug('motor detail: ', res);
        if (res.response_desc == 'Success') {
          this.logger.info(`${this.logSessionText} checkRule getRenewalDetailService success`)

          this.insurance_data = res.data.obj;
          this.isCompulsory = this.insurance_data.isCompulsory;
          this.sharedDataService.setMotorDetail(this.insurance_data);
          if (this.page == 'payment-summary' || this.page == 'qr-barcode') {
            this.onCheckExpirePayment1();
          }
          else {
            this.onCheckExpire();
          }
        }
        else {
          if(this.isCompulsory) {
            this.sendLineMessage("Renew-001-MOTOR-COMP")
          } else {
            this.sendLineMessage("Renew-001-MOTOR");
          }
        }
      }).catch(error => {
        if(error?.error?.message) {
          this.logger.error(`${this.logSessionText} checkRule getRenewalDetailService error:${error?.error?.message}`);
          if(error?.error?.message === 'access_token is required') {
            this.logger.error(`${this.logSessionText} checkRule getRenewalDetailService redirect to line login`);
            liff.logout()
            liff.login({ redirectUri: window?.location?.href })
          }else {
            this.logger.error(`${this.logSessionText} checkRule getRenewalDetailService error:${error?.message}`);
            this.modalService
                              .open(
                                LineModalTemplateComponent,
                                this.lineModalService.setModalConfig(
                                  "alert",
                                  "ไม่สามารถทำรายการได้",
                                  [
                                    "ขออภัย ระบบขัดข้อง ไม่สามารถดึงข้อมูลได้",
                                  ]
                                )
                              )
                              .onResult().subscribe({
                                next: (result2) => {
                                  this.logger.info(`${this.logSessionText} checkRule getRenewalDetailService popup success`);
                                },
                                error: (err2) => {
                                  this.logger.info(`${this.logSessionText} checkRule getRenewalDetailService popup message:${err2}`);
                                },
                                complete: () => {
                                  this.logger.info(`${this.logSessionText} checkRule getRenewalDetailService popup complete`);
                                }
          })
        }
        }else{
          this.logger.error(`${this.logSessionText} checkRule getRenewalDetailService error:${error?.message}`);
          this.modalService
                              .open(
                                LineModalTemplateComponent,
                                this.lineModalService.setModalConfig(
                                  "alert",
                                  "ไม่สามารถทำรายการได้",
                                  [
                                    "ขออภัย ระบบขัดข้อง ไม่สามารถดึงข้อมูลได้",
                                  ]
                                )
                              )
                              .onResult().subscribe({
                                next: (result2) => {
                                  this.logger.info(`${this.logSessionText} checkRule getRenewalDetailService popup success`);
                                },
                                error: (err2) => {
                                  this.logger.info(`${this.logSessionText} checkRule getRenewalDetailService popup fail:${err2?.message}`);
                                },
                                complete: () => {
                                  this.logger.info(`${this.logSessionText} checkRule getRenewalDetailService popup complete`);
                                }
                              })
        }
      });
    } else if (this.product_type == this.ConstantsService.NONMOTOR) {
      this.getRenewalNonmotorDetailService.exec({ dataucid: dataucid }).then((res: any) => {
        this.logger.debug('nonmotor detail: ', res);
        if (res.response_desc == 'Success') {
          this.logger.info(`${this.logSessionText} checkRule getRenewalNonmotorDetailService success`);
          this.insurance_data = res.data.obj;
          this.sharedDataService.setNonmotorDetail(this.insurance_data);
          if (this.page == 'payment-summary' || this.page == 'qr-barcode') {
            this.onCheckExpirePayment1();
          } else {
            this.onCheckExpire();
          }
        } else {
          this.logger.info(`${this.logSessionText} checkRule getRenewalNonmotorDetailService fail send line template:Renew-001-NONMOTOR`);
          this.sendLineMessage("Renew-001-NONMOTOR");
        }
      }).catch(error => {
        if(error?.error?.message) {
          this.logger.error(`${this.logSessionText} checkRule getRenewalNonmotorDetailService error:${error?.error?.message}`);
          if(error?.error?.message === 'access_token is required') {
            liff.logout()
            liff.login({ redirectUri: window?.location?.href })
          }else {
            this.logger.error(`${this.logSessionText} checkRule getRenewalNonmotorDetailService error:${error?.message}`);
            this.modalService
                              .open(
                                LineModalTemplateComponent,
                                this.lineModalService.setModalConfig(
                                  "alert",
                                  "ไม่สามารถทำรายการได้",
                                  [
                                    "ขออภัย ระบบขัดข้อง ไม่สามารถดึงข้อมูลได้",
                                  ]
                                )
                              )
                              .onResult().subscribe({
                                next: (result2) => {
                                  this.logger.info(`${this.logSessionText} getRenewalNonmotorDetailService popup success`);
                                },
                                error: (err2) => {
                                  this.logger.info(`${this.logSessionText} getRenewalNonmotorDetailService popup message:${err2}`);
                                },
                                complete: () => {
                                  this.logger.info(`${this.logSessionText} getRenewalNonmotorDetailService popup complete`);
                                }
                              })
          }
        }else{
          this.logger.error(`${this.logSessionText} checkRule getRenewalNonmotorDetailService error:${error?.message}`);
          this.modalService
                              .open(
                                LineModalTemplateComponent,
                                this.lineModalService.setModalConfig(
                                  "alert",
                                  "ไม่สามารถทำรายการได้",
                                  [
                                    "ขออภัย ระบบขัดข้อง ไม่สามารถดึงข้อมูลได้",
                                  ]
                                )
                              )
                              .onResult().subscribe({
                                next: (result2) => {
                                  this.logger.info(`${this.logSessionText} getRenewalNonmotorDetailService popup success`);
                                },
                                error: (err2) => {
                                  this.logger.info(`${this.logSessionText} getRenewalNonmotorDetailService popup message:${err2}`);
                                },
                                complete: () => {
                                  this.logger.info(`${this.logSessionText} getRenewalNonmotorDetailService popup complete`);
                                }
                              })
        }
      });
    }
  }

  // onCheckExpire() {
  //   this.logger.info('checkExpire');
  //   // lastClaimDate motor _15941
  //   // lastClaimDate non motor _62
  //   let date_expire = new Date(this.insurance_data.lastClaimDate);
  //   let day_expire = date_expire.getDate();
  //   let month_expire = date_expire.getUTCMonth() + 1;
  //   let year_expire = date_expire.getUTCFullYear();

  //   this.logger.info(['date_expire', day_expire, month_expire, year_expire]);
  //   this.logger.info(['date_current', this.day_current, this.month_current, this.year_current]);

  //   if (year_expire == this.year_current) {
  //     if (month_expire == this.month_current) {
  //       if (day_expire == this.day_current) {
  //         if (this.product_type == this.ConstantsService.MOTOR && this.hr_current > 16) {
  //           this.sendLineMessage(this.product_type == this.ConstantsService.MOTOR ? "Renew-003-MOTOR" : "Renew-003-NONMOTOR");
  //         } else if (this.product_type == this.ConstantsService.MOTOR && this.hr_current == 16) {
  //           if (this.minute_current <= 30) {
  //             this.onCheckF09();
  //           } else {
  //             this.sendLineMessage(this.product_type == this.ConstantsService.MOTOR ? "Renew-003-MOTOR" : "Renew-003-NONMOTOR");
  //           }
  //         } else {
  //           this.onCheckF09();
  //         }
  //       } else if (day_expire > this.day_current) {
  //         this.onCheckF09();
  //       } else {
  //         this.sendLineMessage(this.product_type == this.ConstantsService.MOTOR ? "Renew-003-MOTOR" : "Renew-003-NONMOTOR");
  //       }
  //     } else if (month_expire > this.month_current) {
  //       this.onCheckF09();
  //     } else {
  //       this.sendLineMessage(this.product_type == this.ConstantsService.MOTOR ? "Renew-003-MOTOR" : "Renew-003-NONMOTOR");
  //     }
  //   } else if (year_expire > this.year_current) {
  //     this.onCheckF09();
  //   } else {
  //     this.sendLineMessage(this.product_type == this.ConstantsService.MOTOR ? "Renew-003-MOTOR" : "Renew-003-NONMOTOR");
  //   }
  // }

  onCheckExpire() {
    // this.logger.info('checkExpire');
    // lastClaimDate motor _15941
    // lastClaimDate non motor _62
    this.logger.info(`${this.logSessionText} checkExpire start`);
    
    const checkexpire = this.checkexpire(this.insurance_data.lastClaimDate);
    if(checkexpire) {
      if (this.product_type == this.ConstantsService.MOTOR) {
        this.logger.info(`${this.logSessionText} checkExpire send line template:Renew-003-MOTOR`);
        if(this.isCompulsory){
          this.sendLineMessage("Renew-003-MOTOR-COMP");
        }else {
          this.sendLineMessage("Renew-003-MOTOR");
        }
      } else if (this.product_type == this.ConstantsService.NONMOTOR) {
        this.logger.info(`${this.logSessionText} checkExpire send line template:Renew-003-NONMOTOR`);
        this.sendLineMessage("Renew-003-NONMOTOR");
      }
    } else {
      this.logger.info(`${this.logSessionText} checkExpire onCheckF09 start`);
      this.onCheckF09();
    }
  }

  checkexpire (expire:number) {
    this.logger.info(`${this.logSessionText} checkexpire start`);

    let tmp_date_expire = new Date(expire);
    this.logger.info(tmp_date_expire);

    let _now = new Date();
    let now = new Date(Date.UTC(_now.getFullYear(), _now.getMonth(), _now.getDate(), _now.getHours(), _now.getMinutes(), _now.getSeconds(), _now.getMilliseconds()));
    this.logger.info(['now', now]);

    if(this.product_type == this.ConstantsService.MOTOR) {
      this.logger.info(`${this.logSessionText}  checkexpire motor`);
      // expire 16.30
      let expire_date = new Date(Date.UTC(tmp_date_expire.getFullYear(), tmp_date_expire.getMonth(), tmp_date_expire.getDate(), 16, 30, 0, 0));
      this.logger.info(`${this.logSessionText} checkexpire date_expire:${expire_date.getTime()}`);
      if (expire_date.getTime() > now.getTime()) {
        this.logger.info(`${this.logSessionText} checkexpire date_expire > now`);
        return false
      } else {
        // date_expire < today
        this.logger.info(`${this.logSessionText} checkexpire date_expire < now`);
        return true
      }
    } else if(this.product_type == this.ConstantsService.NONMOTOR){
      this.logger.info(`${this.logSessionText} checkexpire non motor`);

      // expire 23.59
      let expire_date = new Date(Date.UTC(tmp_date_expire.getFullYear(), tmp_date_expire.getMonth(), tmp_date_expire.getDate(), 16, 30, 0, 0));
      this.logger.info(`${this.logSessionText} checkexpire non motor date_expire:${expire_date.getTime()}`);

      if (expire_date.getTime() > now.getTime()) {
        this.logger.info(`${this.logSessionText} checkexpire non motor date_expire > now`);

        return false
      } else {
        this.logger.info(`${this.logSessionText} checkexpire non motor date_expire < now`);

        return true
      }
    } else {
      // not support
      this.logger.info(`${this.logSessionText} checkexpire product type not support`);
      throw('not support');
    }
  }

  onCheckExpirePayment1() {    
    this.logger.info(`${this.logSessionText} onCheckExpirePayment1 start`);

    // lastClaimDate motor _15941
    // lastClaimDate non motor _62
    const checkexpire = this.checkexpire(this.insurance_data.lastClaimDate);
    if(checkexpire) {
      this.logger.info(`${this.logSessionText} onCheckExpirePayment1 checkexpire have value`);

      if (this.product_type == this.ConstantsService.MOTOR) {
        this.logger.info(`${this.logSessionText} onCheckExpirePayment1 checkexpire send line template:Renew-003-MOTOR`);
        if(this.isCompulsory) {
          this.sendLineMessage("Renew-003-MOTOR-COMP");
        } else {
          this.sendLineMessage("Renew-003-MOTOR");
        }
      } else if (this.product_type == this.ConstantsService.NONMOTOR) {
        this.logger.info(`${this.logSessionText} onCheckExpirePayment1 checkexpire send line template:Renew-003-NONMOTOR`);
        this.sendLineMessage("Renew-003-NONMOTOR");
      }
    } else {
        this.logger.info(`${this.logSessionText} onCheckExpirePayment1 onCheckDueDate start`);
        this.onCheckDueDate();
    }
  }

  onCheckDueDate() {
    this.logger.info('Check Due Date');
    this.logger.info(`${this.logSessionText} onCheckDueDate start`);
    // paymentMethod motor _13249
    // paymentMethod non motor _13249
    let payment_method = this.insurance_data.paymentMethod.split("|")[0].split(" ")
    let payment_method_date = payment_method[1].split("/")
    let date_expire = new Date(Date.UTC(parseInt(payment_method_date[2]), parseInt(payment_method_date[1]) - 1, parseInt(payment_method_date[0]), 0, 0, 0, 0)).getTime()

    let _now = new Date();
    let now = new Date(Date.UTC(_now.getFullYear(), _now.getMonth(), _now.getDate(), _now.getHours(), _now.getMinutes(), _now.getSeconds(), _now.getMilliseconds()));
    this.logger.info(`${this.logSessionText} onCheckDueDate now:${now}`);

    let _today = new Date(Date.UTC(_now.getFullYear(), _now.getMonth(), _now.getDate(), 0, 0, 0, 0));
    let today = _today.getTime();
    this.logger.info(['_today', _today]);
    this.logger.info(`${this.logSessionText} onCheckDueDate today:${_today}`);


    let _today_1630 = new Date(Date.UTC(_now.getFullYear(), _now.getMonth(), _now.getDate(), 16, 30, 0, 0));
    let today_1630 = _today_1630.getTime();
    this.logger.info(`${this.logSessionText} onCheckDueDate today_1630:${_today_1630}`);


    this.logger.debug('payment_method', payment_method, 'payment_method_date', payment_method_date);
    this.logger.debug('date_expire', date_expire, 'today', today, 'today_1630', today_1630, 'now', now);
    if (today <= date_expire) {
      this.logger.info(`${this.logSessionText} onCheckDueDate today <= due_date`);
      this.logger.info(`${this.logSessionText} onCheckDueDate onCheckF09Payment start`);
      return this.onCheckF09Payment();
    } else {
      this.logger.info(`${this.logSessionText} onCheckDueDate today > due_date`);
      const templateRefMotor = this.isCompulsory ? `Renew-009-MOTOR-COMP` : `Renew-009-MOTOR`
      this.logger.info(`${this.logSessionText} onCheckDueDate send line template:${this.product_type == this.ConstantsService.MOTOR ? templateRefMotor : "Renew-009-NONMOTOR"}`);
      this.sendLineMessage(this.product_type == this.ConstantsService.MOTOR ? templateRefMotor : "Renew-009-NONMOTOR");
    }
  }

  onCheckF09() {
    this.logger.info(`${this.logSessionText} checkF09 start`);

    if (this.product_type == this.ConstantsService.MOTOR) {
      if ((this.insurance_data.checkf09_1 == 30 || this.insurance_data.checkf09_1 == 31 || this.insurance_data.checkf09_1 == this.ConstantsService.updateRenewNonmotorTssSuccess || this.insurance_data.checkf09_1 == this.ConstantsService.updateRenewNonmotorTssFail || this.insurance_data.checkf09_1 == this.ConstantsService.paySuccess || this.insurance_data.checkf09_1 == this.ConstantsService.payFail)
        && (this.insurance_data.checkf09_2 == this.insurance_data.checkf09_3)) {
        this.logger.info(`${this.logSessionText} checkF09 send line template start`);
        const templateRef = this.isCompulsory ? `Renew-004-MOTOR-COMP` : `Renew-004-MOTOR`
        this.logger.info(`${this.logSessionText} checkF09 send line template final:${templateRef}`);
        this.sendLineMessage(templateRef);
      }
      else if ((this.insurance_data.checkf09_1 == 30 || this.insurance_data.checkf09_1 == 31 || this.insurance_data.checkf09_1 == this.ConstantsService.updateRenewNonmotorTssSuccess || this.insurance_data.checkf09_1 == this.ConstantsService.updateRenewNonmotorTssFail || this.insurance_data.checkf09_1 == this.ConstantsService.paySuccess || this.insurance_data.checkf09_1 == this.ConstantsService.payFail)
        && (this.insurance_data.checkf09_2 != this.insurance_data.checkf09_3)) {
        const templateRefMotor = this.isCompulsory ? `Renew-005-MOTOR-COMP` : `Renew-005-MOTOR`
        this.logger.info(`${this.logSessionText} checkF09 send line template:${templateRefMotor}`);
        this.sendLineMessage(templateRefMotor);
      }
      else {
        this.logger.info(`${this.logSessionText} checkF09 onCheckNotify start`);
        this.onCheckNotify();
      }
    } else if (this.product_type == this.ConstantsService.NONMOTOR) {
      this.logger.info(`${this.logSessionText} checkF09 Nonmotor`);

      if (this.insurance_data.checkf09_1 == this.ConstantsService.updateRenewNonmotorTssSuccess || this.insurance_data.checkf09_1 == this.ConstantsService.updateRenewNonmotorTssFail || this.insurance_data.checkf09_1 == this.ConstantsService.updateRenewNonmotor || this.insurance_data.checkf09_1 == this.ConstantsService.paySuccess || this.insurance_data.checkf09_1 == this.ConstantsService.payFail || this.insurance_data.checkf09_1 == this.ConstantsService.payProcessing) {
        this.logger.info(`${this.logSessionText} checkF09 send line template:Renew-004-NONMOTOR`);
        this.sendLineMessage("Renew-004-NONMOTOR");
      }
      else {
        // this.onCheckNotify();
        // this.onRedirect();
        // ตรวจสอบ Wrap Up เเทน Notify400 (WEA03)
        this.logger.info(`${this.logSessionText} checkF09 checkWrapUpNonMotor start`);
        this.checkWrapUpNonMotor();
      }
    }
  }

  onCheckF09Payment() {
    this.logger.info(`${this.logSessionText} onCheckF09Payment start`);

    if ((this.insurance_data.checkf09_1 == this.ConstantsService.paySuccess || this.insurance_data.checkf09_1 == this.ConstantsService.payFail) && (this.insurance_data.checkf09_2 == this.insurance_data.checkf09_3)) {
      const templateRefMotor = this.isCompulsory ? `Renew-004-MOTOR-COMP` : `Renew-004-MOTOR`;
      this.logger.info(`${this.logSessionText} onCheckF09Payment send line template:${this.product_type == this.ConstantsService.MOTOR ? templateRefMotor : "Renew-004-NONMOTOR"}`);
      this.sendLineMessage(this.product_type == this.ConstantsService.MOTOR ? templateRefMotor : "Renew-004-NONMOTOR");
    }
    else if ((this.insurance_data.checkf09_1 == this.ConstantsService.paySuccess || this.insurance_data.checkf09_1 == this.ConstantsService.payFail) && (this.insurance_data.checkf09_2 != this.insurance_data.checkf09_3)) {
      const templateRefMotor = this.isCompulsory ? `Renew-005-MOTOR-COMP` : `Renew-005-MOTOR`;
      this.logger.info(`${this.logSessionText} onCheckF09Payment send line template:${this.product_type == this.ConstantsService.MOTOR ? templateRefMotor : "Renew-005-NONMOTOR"}`);
      this.sendLineMessage(this.product_type == this.ConstantsService.MOTOR ? templateRefMotor : "Renew-005-NONMOTOR");
    }
    else {
      this.logger.info(`${this.logSessionText} onCheckF09Payment onCheckNotify start`);
      this.onCheckNotify();
    }
  }

  onCheckNotify() {
    this.logger.info(`${this.logSessionText} onCheckNotify start`);

    if(this.product_type == this.ConstantsService.MOTOR){
      this.logger.info(`${this.logSessionText} onCheckNotify motor start`); 
      let expire_date = new Date(this.insurance_data.lastClaimDate);
      var month_expire = expire_date.getUTCMonth() + 1;
      var day_expire = expire_date.getDate();
      var year_expire = expire_date.getUTCFullYear();
      if (month_expire < 10) {
        var month = '0' + month_expire.toString();
      }
      else {
        var month = month_expire.toString();
      }
      if (day_expire < 10) {
        var day = '0' + day_expire.toString();
      }
      else {
        var day = day_expire.toString();
      }
      let expired = year_expire.toString() + month + day;
      this.logger.debug('expiredate for checknotify40 service ' + expired);
      this.logger.debug('applicationCode for checknotify40 service ' + this.insurance_data.applicationCode);
      this.logger.debug('accountNo for checknotify40 service ' + this.insurance_data.accountNo);
  
      let bodyNotify = {
        "applicationCode": this.insurance_data.applicationCode,
        "accountNo": this.insurance_data.accountNo,
        "expireDate": expired
      }
      this.callNotify.exec(bodyNotify).then((res: any) => {
        if (res.notifyStatus) {
          if (res.notifyStatus == 'Y') {
            const templateRefMotor = this.isCompulsory ? `Renew-004-MOTOR-COMP` : `Renew-004-MOTOR`
            this.sendLineMessage(this.product_type == this.ConstantsService.MOTOR ? templateRefMotor : "Renew-004-NONMOTOR");
          }
          else if (res.notifyStatus == 'N') {
            this.onRedirect();
          }
        }
        else {
          this.logger.info(`${this.logSessionText} onCheckNotify callNotifyService Error:${res.returnDesc} Code:${res.returnCode}`)
          // this.onRedirect();
        }
      }).catch((error) => {        
          this.logger.error(`${this.logSessionText} onCheckNotify callNotifyService fatal error:${error?.message}`);
          this.modalService
                              .open(
                                LineModalTemplateComponent,
                                this.lineModalService.setModalConfig(
                                  "alert",
                                  "ไม่สามารถทำรายการได้",
                                  [
                                    "ขออภัย ระบบขัดข้อง ไม่สามารถดึงข้อมูลได้",
                                  ]
                                )
                              )
                              .onResult().subscribe({
                                next: (result2) => {
                                  this.logger.info(`renewal callNotifyService popup success`);
                                },
                                error: (err2) => {
                                  this.logger.info(`renewal callNotifyService popup message:${err2}`);
                                },
                                complete: () => {
                                  this.logger.info(`renewal callNotifyService popup complete`);
                                }
                              })
        // this.onRedirect();
      })
    } else if(this.product_type == this.ConstantsService.NONMOTOR){
      // ตรวจสอบ Wrap Up เเทน Notify400 (WEA03)
      this.logger.info(`${this.logSessionText} onCheckNotify checkWrapUpNonMotor`);
      this.checkWrapUpNonMotor();
    }
  }

  onRedirect() {
    this.logger.info(`${this.logSessionText} onRedirect start page:${this.page}`);

    if (this.page == 'payment-summary') {
      if(this.credit_status == 1){
        this.updateOmise();
      } else {
        this.navigationExtras = {
          queryParams: {
            "dataucid": this.ducid,
            "letterucid": this.lucid,
            "rm_channelId": this.rm_channelId,            
            "appRef": this.liffId,
            "payment_method": this.paymentMethod,
            "product_type": this.product_type,
            "amount": this.amount,
            "page": this.page,
            // "user_id": this.userId,
            "electronic_channel": this.electronic_channel,
            "comcode": this.comcode,
            "liff_channel_id":this.liff_channel_id,
            "channel_line_id": this.channel_line_id,
            "subchannel": this.subChannel
          }
        };
        this.router.navigate(['/renewal/' + this.page], this.navigationExtras);
      }
    } else if (this.page.includes("payment-callback")) {
      this.logger.debug('this.page else if payment callback')
      this.navigationExtras = {
        queryParams: {
          "result": this.result,
          "payment_method": this.payment_method,
          "card_number": this.card_number,
          "liff_channel_id":this.liff_channel_id,
          "channel_line_id": this.channel_line_id,
          "liffId": this.liffId,
          "subchannel": this.subChannel
        }
      };
      this.router.navigate(['/renewal/' + this.page], this.navigationExtras);
    }
    else if (this.page == 'qr-barcode') {
      this.navigationExtras = {
        queryParams: {
          "dataucid": this.ducid,
          "letterucid": this.lucid,
          "rm_channelId": this.rm_channelId,
          "appRef": this.liffId,
          "product_type": this.product_type,
          "amount": this.amount,
          "page": this.page,
          // "user_id": this.userId,
          "electronic_channel": this.electronic_channel,
          "comcode": this.comcode,
          "liff_channel_id":this.liff_channel_id,
          "channel_line_id": this.channel_line_id,
          "subchannel": this.subChannel
        }
      };
      this.router.navigate(['/renewal/' + this.page], this.navigationExtras);
    }
    else {
      this.navigationExtras = {
        queryParams: {
          "dataucid": this.ducid,
          "letterucid": this.lucid,
          "rm_channelId": this.rm_channelId,
          "appRef": this.liffId,
          "product_type": this.product_type,
          "page": this.page,
          // "user_id": this.userId,
          "electronic_channel": this.electronic_channel,
          "comcode": this.comcode,
          "liff_channel_id":this.liff_channel_id,
          "channel_line_id": this.channel_line_id,
          "subchannel": this.subChannel
        }
      };
      this.router.navigate(['/renewal/' + this.page], this.navigationExtras);
    }
  }

  checkWrapUpNonMotor() {
    // ตรวจสอบ Wrap Up เเทน Notify400 (WEA03)
    this.logger.info(`${this.logSessionText} checkWrapUpNonMotor start`);

    let body = {
      "app_code": this.insurance_data.appCode,
      "account_no": this.insurance_data.accountNo,
    }
    this.logger.info(`${this.logSessionText} checkWrapUpNonMotor checkWrapUpNonMotorService start`);

    this.checkWrapUpNonMotorService.exec(body).then((res: any) => {
      if(res.response_code == '40000' && res.response_desc == 'Success') {
        if(res.response_status == true) {
          this.logger.info(`${this.logSessionText} checkWrapUpNonMotor checkWrapUpNonMotorService success send line template:Renew-004-NONMOTOR`);
          this.sendLineMessage("Renew-004-NONMOTOR");
        } else {
          this.logger.info(`${this.logSessionText} checkWrapUpNonMotor checkWrapUpNonMotorService success onRedirect`);
          this.onRedirect();
        }
      } else {
        this.logger.info(`${this.logSessionText} checkWrapUpNonMotor checkWrapUpNonMotorService fail:${JSON.stringify(res)}`);

        this.modal.show({
          title: 'Header Information',
          body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์'
        });
      }
    }).catch((error) => {
      this.logger.error(`${this.logSessionText} checkWrapUpNonMotor checkWrapUpNonMotorService fatal error:${error?.message}`);

      this.modal.show({
        title: 'Header Information',
        body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์'
      });
    });
  }

  updateOmise() {
    this.logger.info(`${this.logSessionText} updateOmise start`);
    let param = {
      dataucid: this.ducid,
      amount: Number(this.amount)
    };
    // call api
    let data_omise;
    this.logger.info(`${this.logSessionText} updateOmise updateRenewNonMotorOmiseService start`);
    this.updateRenewNonMotorOmiseService.exec(param).then(async (response_omise) => {
      if(response_omise['response_code'] == "40000"){
        data_omise = response_omise['response_data'];
        let body = {
          app_code: data_omise['1_2954']._6229,
          account_no: data_omise['1_2954']._40,
          classify_insure : "M_HIP"
        };
        this.logger.info(['getWrapUpQrPayment Body', body]);

        return this.getWrapUpQrPayment.exec(body);
      } else {
        this.modal.show({
          title: 'Header Information',
          body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์'
        });
      }

    }).then(async (res) => {
      this.logger.info(`${this.logSessionText} updateOmise getWrapUpQrPayment response success`);

      let agent1 = null;
      let agent2 = null;
      if (res['data'] != null) {
        agent1 = res['data']._11784;
        agent2 = res['data']._16220;
      }
      this.logger.info(`${this.logSessionText} updateOmise getNonMotorPaymentSummary start`);
      const paymentSummary = await this.getNonMotorPaymentSummary.exec({ dataucid: this.ducid, letterucid: this.lucid })
      this.logger.info(`${this.logSessionText} updateOmise getNonMotorPaymentSummary response success`);
      let now = new Date();
      let DD = now.getDate();
      let MM = now.getMonth() + 1;
      let YYYY = now.getFullYear();
      let DD_str: string = DD < 10 ? `0${DD}` : `${DD}`;
      let MM_str: string = MM < 10 ? `0${MM}` : `${MM}`;
      let YYYY_str: string = `${YYYY.toString()}`;
      let date_today = `${DD_str}/${MM_str}/${YYYY_str}`;

      let lead_date = new Date(data_omise['1_2953']._601);
      DD = lead_date.getDate();
      MM = lead_date.getMonth() + 1;
      YYYY = lead_date.getFullYear();
      DD_str = DD < 10 ? `0${DD}` : `${DD}`;
      MM_str = MM < 10 ? `0${MM}` : `${MM}`;
      YYYY_str = `${YYYY.toString()}`;
      let lead_date_str = `${DD_str}/${MM_str}/${YYYY_str}`;

      let tss_body = {
        app_code: data_omise['1_2953']._6229,
        account_no: data_omise['1_2953']._40,
        lead_date: lead_date_str,
        client_no: data_omise['1_2953']._15812,
        classify_insure: "2",
        f09_update_inform: "50",
        // quotation_selected: "",
        payment_type: "1",
        payment_method: data_omise['1_2953']._13249,
        payment_status: false,
        payment_amount: this.amount,
        payment_summary: paymentSummary['data'] ? paymentSummary['data'] : "",
        payment_date: date_today,
        agent1: agent1 ? agent1 : null,
        agent2: agent2 ? agent1 : null,
      };

      const logTssBody = {
        ...tss_body,
        account_no : this.getMaskingService.maskingData(tss_body.account_no),
        client_no: this.getMaskingService.maskingData(tss_body.client_no),
        payment_amount : this.getMaskingService.maskingData(tss_body.payment_amount),
        payment_summary : this.getMaskingService.maskingData(tss_body.payment_summary),
        agent1 : this.getMaskingService.maskingData(tss_body.agent1),
        agent2 : this.getMaskingService.maskingData(tss_body.agent2),
      }

      this.logger.info(`${this.logSessionText} updateOmise callTss body:${JSON.stringify(logTssBody)}`);


      return this.callTss.exec(tss_body);

    }).then(async (res) => {
      this.logger.info(`${this.logSessionText} updateOmise callTss res:${JSON.stringify(res)}`);

      let f09_status = this.ConstantsService.payFail;
      if (res['response_code'] == "40000") {
        f09_status = this.ConstantsService.paySuccess;
      }

      let bodyUpdate_f09 = {
        dataucid: this.ducid,
        f09status: f09_status,
      };

      this.logger.info(`${this.logSessionText} updateOmise callTss updateF09 body:${JSON.stringify(bodyUpdate_f09)}`);

      return this.updateF09StatusService.exec(bodyUpdate_f09);

    }).then(async (res) => {

      this.logger.info(`${this.logSessionText} updateOmise callTss updateF09 res:${JSON.stringify(res)}`);
      if (res['response_code'] == "40000") {
        this.logger.info(`${this.logSessionText} updateOmise callTss updateF09 send line template:Renew-011-NONMOTOR`);

        this.sendLineMessage("Renew-011-NONMOTOR");
      } else {
        this.logger.info(`${this.logSessionText} updateOmise callTss updateF09 fail`);
        this.modal.show({
          title: 'Header Information',
          body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์'
        });
      }
    }).catch(error=>{
      this.logger.error(`${this.logSessionText} updateOmise fatal error:${error?.message}`);
      this.modal.show({
          title: 'Header Information',
          body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์'
        });
    });
  }

  sendLineMessage(templateRef) {
    this.logger.info(`${this.logSessionText} sendLineMessage start`);
    let expire_date = "";
    let company = "";
    if (templateRef == "Renew-005-MOTOR" || templateRef == "Renew-005-MOTOR-COMP") {
      company = this.insurance_data.templateCompanyName;
    }
    if (templateRef == "Renew-000-NONMOTOR") {
      let lastClaimDate = new Date(this.insurance_data.lastClaimDate);
      let month = lastClaimDate.getUTCMonth() + 1;
      let day = lastClaimDate.getDate();
      let year = lastClaimDate.getUTCFullYear() + 543;
      expire_date = day + '/' + month + '/' + year;
    }

    // this.userId = 'Udadc4f8639df4d33a48f95ae5024fb57';

    const populateLine = {
      // customerId: this.userId,
      channelId: this.rm_channelId,
      templateRef: templateRef,
      templateParameter: {
        "company": company,
        "expire_date": expire_date
      },
      message: []
    }
    this.logger.info(`${this.logSessionText} sendLineMessage body:${JSON.stringify(populateLine)}`);

    this.sendLineMessageService.exec(populateLine).then(async (res) => {
      this.logger.debug('sendLineMessageService', res)
      if (res['status'] == true) {
        liff.closeWindow();
        this.logger.info(`${this.logSessionText} sendLineMessage success`);
      }
      else {
        this.logger.info(`${this.logSessionText} sendLineMessage fail`);
        liff.closeWindow();
      }
    }).catch((error) => {
        this.logger.error(`${this.logSessionText} sendLineMessage fatal error:${error?.message}`);
        this.modalService
                              .open(
                                LineModalTemplateComponent,
                                this.lineModalService.setModalConfig(
                                  "alert",
                                  "ไม่สามารถทำรายการได้",
                                  [
                                    "ขออภัย ระบบขัดข้อง ไม่สามารถดึงข้อมูลได้",
                                  ]
                                )
                              )
                              .onResult().subscribe({
                                next: (result2) => {
                                  this.logger.info(`${this.logSessionText} sendLineMessage popup success`);
                                },
                                error: (err2) => {
                                  this.logger.info(`${this.logSessionText} sendLineMessage popup message:${err2}`);
                                },
                                complete: () => {
                                  this.logger.info(`${this.logSessionText} sendLineMessage popup complete`);
                                }
                              })
    });
  }
}
